import { render, staticRenderFns } from "./MobileEventShare.vue?vue&type=template&id=fcd84a54&scoped=true"
import script from "./MobileEventShare.vue?vue&type=script&lang=ts"
export * from "./MobileEventShare.vue?vue&type=script&lang=ts"
import style0 from "./MobileEventShare.vue?vue&type=style&index=0&id=fcd84a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd84a54",
  null
  
)

export default component.exports